import Vue from "vue";

const EventBus = (() => {
  const bus = new Vue();
  const emit = (eventName: string, payload?: any) => {
    bus.$emit(eventName, payload);
  };

  const listen = (
    eventName: string,
    cb: (payload?: any) => void
  ): (() => void) => {
    bus.$on(eventName, cb);
    const off = () => bus.$off(eventName, cb);
    return off;
  };

  const GLOBAL_EVENTS = {
    CLOSE_ALL_MODALS: "CLOSE_ALL_MODALS",
  };

  return {
    emit,
    listen,
    GLOBAL_EVENTS,
  };
})();

export { EventBus };
